import type {IconName as UiIconName} from '@awesome.me/kit-4bfc2309f5/icons';
import type {IconName as ResourceIconName} from '@awesome.me/kit-05a70cf04e/icons';
import type {IconName as TagIconName} from '@awesome.me/kit-1af7222dbb/icons';

export type IconName = UiIconName | ResourceIconName | TagIconName | 'notdef';

export type IconWeight = 'solid' | 'regular';

const WEIGHT_TO_PREFIX: Record<IconWeight, string> = {
    solid: 'fas',
    regular: 'far',
};

export function getPrefixByWeight(weight: IconWeight): string {
    return WEIGHT_TO_PREFIX[weight] ?? '';
}
